export interface  ListComparisonsParams {
  applicationType: ApplicationType;
  comparisonType: ComparisonType;
}

export interface ComparisonProps {
  id?: string;
  user_keycloak_id?: string;
  name?: string;
  comparisonType?: ComparisonType;
  applicationType?: ApplicationType;
  team_id?: string | null | undefined;
  assets?: string[];
  config?: {
    period?: string;
    currency?: string;
    listConfig?: TableConfig;
  };
  created_at?: Date;
  updated_at?: Date;
  folder_item_id?: string;
}

export interface ComparisonResponse {
  id: string;
  user_keycloak_id: string;
  name: string;
  comparisonType: ComparisonType;
  applicationType: ApplicationType;
  team_id: string | null | undefined;
  assets: string[];
  config: {
    period: string;
    currency: string;
    listConfig: TableConfig;
  } | null;
  created_at: Date;
  updated_at: Date;
  folder_item_id: string;
}

export interface TableConfig {
  [tableConfigName: string]: {
    column: {
      visible: boolean;
      isOrderBy: boolean;
      isGroupBy: boolean;
    };
  };
}

export interface CreateComparisonResponse {
  comparisonId: string;
}

export enum ApplicationType {
  PRO = 'PRO',
  PRIME = 'PRIME',
}

export enum ComparisonType {
  FUND = 'FUND',
  ASSET = 'ASSET',
}